import { Helmet } from "react-helmet";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
  Radio,
  Icon,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom'
import React, { useEffect, useMemo } from "react";
import { ReactComponent as PersonalActive } from "../../../icons/personal-active.svg";
import { ReactComponent as TeamActive } from "../../../icons/team-active.svg";
import { ReactComponent as CompActive } from "../../../icons/comp-active.svg";
import { ReactComponent as PersonalInActive } from "../../../icons/personal-inactive.svg";
import { ReactComponent as TeamInActive } from "../../../icons/team-inactive.svg";
import { ReactComponent as CompInActive } from "../../../icons/comp-inactive.svg";
import { filter } from 'lodash';

import { ReactComponent as BackIcon } from "../../../icons/arrow-left.svg";
import { getGoalType } from "../../../actions/mygoal";

const MyGoalChooseType = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();

  const styles = {
    link: {
      color: "#5DA196",
      cursor: "pointer",
    },
    end: {
      color: "#A3A3A3",
    },
  };

  // Function Start
  const back = (val) => {
    if (showAlignment) {
      setShowAlignment(false);
    } else {
      goto(val, state)
    }
  }

  const goto = (route, data) => {
    if (route) {
      if (route === 'mygoal' && state.isEvaluator && state.formEvaluateId) route += '/' + state.formEvaluateId

      route = '/' + route
    }

    navigate("/kpi" + route, { replace: false, state: data });
  }

  const chooseGoalType = (val) => {
    setGoalType(val)
  }

  const gotoCreateGoal = () => {
    Object.assign(state, { goalType: goalType })
    if (passToEdit) {
      Object.assign(state, { sendGoalType: goalType })
      goto('mygoal-create/edit', state)
    } else {
      goto('mygoal-create/guide', state)
    }
  }
  // Function End

  // Variable Start
  const [showAlignment, setShowAlignment] = React.useState(false);
  const [goalTypeOption, setGoalTypeOption] = React.useState([])
  const [goalType, setGoalType] = React.useState(null);
  const [passToEdit, setPassToEdit] = React.useState(false);
  // Variable End


  const getTitle = () => {
    let title = t('mygoal.label.title')

    if (state?.isEvaluator && state?.owner?.code) {
      title = state?.owner.firstname + ' ' + state?.owner.lastname
      title += '\'s ' + t('label.goal')
    }

    return title
  }

  useEffect(() => {
    dispatch(getGoalType(state.serial))
      .then(resp => {
        let goalTypeList = resp.data?.goalTypeList ?? []


        if (resp.data?.customize?.goal_type) {
          const customizeGoalType = resp.data?.customize?.goal_type ?? []
          goalTypeList = filter(goalTypeList, (g) => { return customizeGoalType.indexOf(g.code) !== -1 })
        }

        setGoalTypeOption(goalTypeList);

        if (state) {
          if (state?.sendGoalType) {
            setGoalType(resp.data.goalTypeList.filter((item) => item.id === state.sendGoalType) ? state.sendGoalType : null)
            setPassToEdit(true)
          }
        }
      })
  }, [])

  useEffect(() => {
    if (goalTypeOption.length === 1) chooseGoalType(goalTypeOption[0].id)
  }, [goalTypeOption])

  return (
    <>
      <Helmet>
        <title>{getTitle()} | KPI </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container pt={2} pb={2}>
            <Typography fontSize={16} lineHeight={1} color="#68717A">
              <span style={styles.link} onClick={() => goto('kpi/home')}>
                {t('label.home')}
              </span> /
              <span style={styles.link} onClick={() => goto('mygoal', state)}>
                {` ${getTitle()}`}
              </span> /
              <span style={styles.end} >
                {` ${t('mygoal.page.createGoal')}`}
              </span>
            </Typography>
          </Grid>
          <Grid container textAlign="center" mb={3}>
            <Grid item md={12} >
              <Typography variant="h1" fontSize={36} lineHeight="39.6px" fontWeight="600" color="#404349">
                {t('mygoal.label.labelGoalType')}
              </Typography>
            </Grid>
            <Grid item md={12} pr={1} mt={1} mb={3}>
              <Typography fontSize={16} fontWeight={400} color="#404349">
                {t('mygoal.label.labelGoalDetail')}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={15} pl={3} pr={3} pb={20} justifyContent="center">
            {goalTypeOption?.map((item, idx) => {
              return (
                <Grid lg={3} xs={12} key={idx} item>
                  <Card style={goalType == item.id ? { border: '1px solid #5DA196', cursor: 'pointer', cursor: 'pointer' } : { border: null }} onClick={() => { chooseGoalType(item.id) }}>
                    <CardContent>
                      <Grid item lg={12} xs={12} container textAlign="center">
                        <Grid item>
                          <Radio name="radio" value="1" checked={goalType === item.id} size="small" />
                        </Grid>
                        <Grid item lg={12}>
                          {item.id == 3 ? (goalType === 3 ? <PersonalActive /> : <PersonalInActive />) :
                            item.id == 2 ? (goalType === 2 ? <TeamActive /> : <TeamInActive />) :
                              (goalType === 1 ? <CompActive style={{ marginBottom: '10px' }} /> : <CompInActive style={{ marginBottom: '10px' }} />)
                          }
                        </Grid>
                        <Grid item lg={12} mt={3}>
                          <Typography fontSize={16} lineHeight="21px" fontWeight="500">
                            {item.description}
                          </Typography>
                        </Grid>
                        <Grid item lg={12} mt={2}>
                          <Typography fontSize={13} variant="label" fontWeight={400} style={{ color: '#A3A3A3' }}>
                            {item.id == 3 ? t('mygoal.label.personalDesc') : item.id == 2 ? t('mygoal.label.teamDesc') : t('mygoal.label.corpDesc')}
                          </Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              )
            })}
          </Grid>
          <Grid container direction="row" style={{ marginTop: '85px' }}>
            <Grid container xs={1} direction="row" style={{ alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={() => back(`/mygoal-choose-create`)}>
              <Grid item mt={0.5}>
                <BackIcon />
              </Grid>
              <Grid item ml={1}>
                <Typography fontWeight={500} fontSize={'18px'} color={'#6B6B6B'}>
                  {t('label.back')}
                </Typography>
              </Grid>
            </Grid>
            <Grid lg={10} xs={12} item textAlign="center">
              <Button
                size="small"
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={() => { gotoCreateGoal() }}
                color="primary"
                variant="contained"
                style={{ paddingLeft: 30, paddingRight: 30, textTransform: 'none', backgroundColor: goalType === null ? '#BABABA' : '#5DA196' }}
                disabled={goalType === null}
              >
                <Typography fontWeight={500} fontSize={'18px'} color={'#FFFFFF'}>{t('label.next')}</Typography>
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};
export default MyGoalChooseType;
